<section class="upload-cv-page">
  <div class="upload-cv-card">

    <div class="page-header">
      <span class="badge">
        {{ 'atw.uploadCv.badge' | transloco }}
      </span>

      <h1>
        {{ 'atw.uploadCv.title' | transloco }}
      </h1>

      <p>
        {{ 'atw.uploadCv.subtitle' | transloco }}
      </p>
    </div>

    <div class="form-group">
      <label for="jobTitle">
        {{ 'atw.uploadCv.jobTitleLabel' | transloco }}
      </label>

      <select
        id="jobTitle"
        class="job-select"
        [value]="selectedJob"
        (change)="onJobChange($event)"
      >
        <option value="" disabled>
          {{ 'atw.uploadCv.jobTitlePlaceholder' | transloco }}
        </option>

        <option
          *ngFor="let job of jobOptions; trackBy: trackByJobValue"
          [value]="job.value"
        >
          {{ job.labelKey | transloco }}
        </option>
      </select>

      <small *ngIf="errorMessageKey" class="error-message">
        {{ errorMessageKey | transloco }}
      </small>
    </div>

    <div class="job-options">
      <button
        type="button"
        class="job-option"
        *ngFor="let job of jobOptions; trackBy: trackByJobValue"
        [class.active]="selectedJob === job.value"
        (click)="selectJob(job)"
      >
        <strong>
          {{ job.labelKey | transloco }}
        </strong>

        <span>
          {{ job.descriptionKey | transloco }}
        </span>
      </button>
    </div>

    <button
      type="button"
      class="continue-btn"
      (click)="goToSelectedForm()"
    >
      {{ 'atw.uploadCv.continue' | transloco }}
    </button>

  </div>
</section>